import { render } from "./ModalAdicionarSite.vue?vue&type=template&id=e2b9fcc2&ts=true"
import script from "./ModalAdicionarSite.vue?vue&type=script&lang=ts"
export * from "./ModalAdicionarSite.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Projects\\anc-transparencia\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__